const hasTelegramLaunchParams = (): boolean => {
  const hash = window.location.hash.startsWith('#') ? window.location.hash.slice(1) : window.location.hash;
  const params = new URLSearchParams(hash);

  return params.has('tgWebAppPlatform') || params.has('tgWebAppStartParam');
};

export const isTelegramWebAppContext = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.Telegram?.WebApp != null || hasTelegramLaunchParams();
};
